const getCabinPrice = (cabinPriceBreakdown) => {
  let result = 0;
  if (cabinPriceBreakdown && cabinPriceBreakdown.totalPassengerStatementLines) {
    cabinPriceBreakdown.totalPassengerStatementLines.forEach((l) => {
      if (l.type === 'TOTAL AMOUNT') {
        result = +l.amount;
      }
    });
  }
  return result;
};

export default getCabinPrice;
